import axios from 'axios'
import moment from 'moment'
import bowser from 'bowser'
import axiosRetry from 'axios-retry'
import {EventEmitter} from 'fbemitter'
import init_third_party, {AGENT_WIDGET_SERVER} from './init_third_party.coffee'
import initAgentView, {clearAgentWidgetSession} from './init_agent_view.coffee'
import {clearWarmedManifests} from './Game/manifest_warm.coffee'
import createjs from 'createjs'
import { setThemeColor } from './common.coffee'
import localeToVoiceMapping from './Game/locale-to-voice-mapping.json'
import locales from '../../../../schema/framework/shared/locales.json'
import { scheduleReloadIfUpdateAvailable } from '../../../../schema/framework/shared/client_version.coffee'
import { rememberIdentity, forgetIdentity, getIdentity } from './crash_reporter.coffee'



bowserRes = bowser.getParser(window.navigator.userAgent).parse().parsedResult

export default class Application
  emitter: new EventEmitter()
  identifier: 0
  browserLocale: navigator.language
  postHistoryFile: (id, post_data, cb) ->
    return axios.put "https://s3-us-west-1.amazonaws.com/historyvideos/#{id}", post_data,
      headers:
        "Content-Type": "application/json"

  fetchHistory: (id) ->
    return axios.get "https://s3-us-west-1.amazonaws.com/historyvideos/#{id}"

  constructor: (@loopbackAPI) ->
    # Linux reports no OS version, so a bare interpolation logged "Linux undefined".
    console.log "Browser information #{bowserRes.browser.name} with #{bowserRes.browser.version} on #{[bowserRes.os.name, bowserRes.os.version].filter(Boolean).join(' ')}"
    console.log "User Agent: #{window.navigator.userAgent}"
    console.log "isChromebook? #{@isChromebook()}"

    @supportedBrowser = if bowserRes.browser.name in ['Chrome', 'Safari'] && !@isFacebookApp() then true else false
    @deltas = {}
    # A NEW Application HAS AN EMPTY FAMILY, NOT A MISSING ONE — card
    # 6aade038bf4219e77902d92f. These four were only ever assigned in setup(),
    # which runs when an account has been fetched. Anything that rendered
    # before that first fetch read `undefined[undefined]` and threw, and what
    # the person saw was the ErrorScreen — "We have encountered an error" —
    # instead of their child. Empty is the truthful pre-load state and every
    # reader already handles it.
    @students = []
    @sharedStudents = []
    @parentInvitations = []
    
  isAndroid511: ->
    return bowserRes.os.name == "Android" && bowserRes.os.version == "5.1.1"

  getUniqueIdentifier: ->
    return "#{@identifier++}"

  savedDashboardTab: =>
    return @dashboard_tab || 0

  clearDashboardTab: =>
    delete @dashboard_tab

  saveDashboardTab: (save) =>
    @dashboard_tab = save

  historyQueryStart: =>
    return @historyStartQuery

  historyQueryEnd: =>
    return @historyEndQuery

  historyQueryEventType: =>
    return @historyEventTypeQuery

  historySorts: =>
    return @historyQuerySorts

  setQueryStart: (save) =>
    @historyStartQuery = save

  setQueryEnd: (save) =>
    @historyEndQuery = save

  setQueryEventType: (value) =>
    @historyEventTypeQuery = value

  setHistorySorts: (value) =>
    @historyQuerySorts = value

  trackCancellation: (user, reason) =>
    if mixpanel?
      console.log "Track cancellation: #{mixpanel?.track?}"
      mixpanel.track?("2: Cancellation", {email: user.email, has_invoices: user.invoices?, reason: reason})
    else
      console.error "Failed to track cancellation in MixPanel"
    dataLayer.push {event: 'Cancellation', cancel_reason: reason} if dataLayer?

  trackReactivation: () ->
    console.log "Tracking reactivation..."
    if mixpanel?
      mixpanel.track?("2: Reactivation")

  trackError: (error) ->
    console.error "Application Error:", error

  trackCancelReason: (reason, title) ->
    window.app.trackPageView("2: Cancel - #{reason}")

  trackLead: () ->
    unless @login?.leadTracked
      # No pintrk('track', 'lead') here — GTM v71 fires Pinterest's Lead off
      # the dataLayer push below, and firing both double-counted every lead
      # on tag 2617750729731 (card 6aac2dee72627e68c3d1f63b).
      uetq = window.uetq
      if uetq?
        window.uetq.push 'event', 'Lead', {action: 'Lead', event_label: 'User Application', event_value: 0}
      if dataLayer?
        dataLayer.push {event: 'Lead'}
      
      if fbq?
        fbq('track', 'InitiateCheckout', {})
      # mark lead tracked, so that it only happens once
      if @login?
        @loopbackAPI.Login.mark_lead({id: @login.id}).then (response) =>
          @login.leadTracked = true
          return response.data.event_id
        .catch (err) =>
          console.error "Failed to mark lead tracked"
          return undefined
        .then (event_id) =>
          if fbq?
            fbq('track', 'Lead', {}, {eventID: event_id})

      # return null, so that nothing is waiting on this
      return null

  trackUser: (user, create = false)=>
    console.log "Track User Being called!"
    if mixpanel?
      mixpanel.identify? user.id
      mixpanel.people.set? {first_name: user.first_name, last_name: user.last_name, email: user.email}
    # The Drip identify that stood here went into `_dcq`, a global Drip stopped
    # defining when it was discontinued (card 6aa6240fccd8b5ca98a6d805). mixpanel
    # above is the live analytics path.

  trackPageView: (page)=>
    console.log "Track Page View #{page}"
    mixpanel.track? "#{page}" if mixpanel?
    fbq('track', 'PageView') if fbq?
    dataLayer.push {event: 'pageview', page: page} if dataLayer?

  trackPurchase: (user, price, currency, event_id) =>
    # Keep the plan's own amount and currency before the USD estimate below
    # overwrites them. The Facebook leg sends these untouched so that it agrees
    # exactly with the server CAPI leg, which sends the same event_id and the
    # same plan amount (common/facebook.coffee trackSubscribe). Facebook dedups
    # the two events against each other and keeps one, so if they disagreed on
    # the amount the reported value would depend on which arrived first.
    fb_value    = if price? then "#{(parseFloat(price) or 0).toFixed(2)}" else null
    fb_currency = "#{currency or 'USD'}".toUpperCase()

    # estimate the conversion rate to USD
    switch currency?.toLowerCase()
      when 'eur' then price = price * 1.19
      when 'gbp' then price = price * 1.33
      when 'inr' then price = price * 0.013
      when 'cad' then price = price * 0.76
      when 'aud' then price = price * 0.73
      when 'ils' then price = price * 0.30
      when 'php' then price = price * 0.021
      when 'mxn' then price = price * 0.05
      when 'nzd' then price = price * 0.69
      else
        # no conversion necessary (assumed to be dollars)

    # convert price to a string
    price = price.toFixed(2)

    console.log "Tracking Purchase of #{price} (USD)"
    
    if mixpanel?
      console.log "Track mixpanel"
      mixpanel.track?("2: Subscribed", {Price: price, Plan: "Monthly"})
      mixpanel.people.track_charge?(price)
    
    if fbq?
      console.log "Track fbq"      
      # The real plan amount, not '0.00'. See fb_value above — this must stay in
      # step with common/facebook.coffee trackSubscribe.
      fbq('track', 'Subscribe', {
        'subscription_id': user.accountId,
        'value': fb_value,
        'currency': fb_currency
      }, {
        'eventID': event_id || "#{user.accountId}-#{Date.now()}"
      })
    # No pintrk('track', 'checkout') here — GTM v71's Checkout tag reads the
    # order value from the `subscribe_value` on the dataLayer push below.
    # Firing both reported every checkout to Pinterest Ads twice (card
    # 6aac2dee72627e68c3d1f63b).
    uetq = window.uetq
    if uetq?
      console.log "uetq tracking"
      window.uetq.push 'event', 'Subscribe', {action: 'Subscribe', event_label: 'User Subscribed', event_value: price}
    if dataLayer?
      console.log "Data layer tracking"
      dataLayer.push {
        event: 'Subscribe',
        transactionId: user.id,
        email: user.email,
        transactionTotal: price,
        google_tag_params: {
          ecomm_pagetype: 'purchase'
          ecomm_totalvalue: price
          ecomm_transId: user.id
        },
        subscribe_value: price
      }

    # VWO tracking
    console.log "VWO Tracking:"
    window._vis_opt_queue = window._vis_opt_queue || []
    if window._vis_opt_revenue_conversion?
      window._vis_opt_queue.push () ->
        window._vis_opt_revenue_conversion(price)

  log: (text) =>
    if @bridge?
      @bridge.callHandler 'log', {text: text}, (responseData) ->
        console.log("-JS received log response ------------:", responseData)

  ready: ()=>
    console.log "Calling ready"
    @log( "READY HAS BEEN CALLED!")
    if bowserRes.os.name == 'iOS'
      @setupWebViewJavascriptBridge (bridge)=>
        console.log "iOS Javascript bridge loaded"

        # modify the html viewport to fill the screen
        console.warn "iOS App :: viewport fit hack"
        root = document.getElementById('root')
        root.style.height = '100vh'
        root.style.width = '100vw'

        # unfortunately necessary, see https://trello.com/c/laH9Urr1
        document.addEventListener 'focusout', (event) ->
          if event.target?.tagName == "INPUT" && event.target?.type in ['text', 'email', 'password']
            console.warn "iOS App :: scrollTo hack"
            window.scrollTo(window.scrollX || 0, window.scrollY || 0)

        @bridge = bridge

        # let everyone know that window.app.isApp has changed
        document.dispatchEvent(new Event('el-is-app-changed'))

        # bridge is loaded, clear device loading screen and get version
        @bridge.callHandler 'cancelLoading', {retVal: true}, (responseData) ->
          if responseData?.version?
            window.config.appVersion = responseData.version
          console.log("-JS received Cancel Loading response ------------:", responseData)
    else if bowserRes.os.name == 'Android'
      console.log "ready: Android has window.cancelLoading: #{window.cancelLoading?}"
      window.cancelLoading?()

    # clear local loading screen (React loading screen will take over if needed)
    obj = document.getElementById("loading")
    obj.remove?() if obj?

  lockOrientationIOS: ->
    if @bridge?
      @bridge.callHandler 'lockOrientation', {retVal: false}, (responseData) ->
        console.log("JS received response:", responseData)

  lockLandscapeOrientation: ->
    if @bridge?
      @bridge.callHandler 'lockLandscape', {retVal: false}, (responseData) ->
        console.log("JS received response:", responseData)
    else if 'screen' of window && 'orientation' of window.screen && 'lock' of window.screen.orientation && @isApp()
      console.log "Locking using SCREEN!"
      window.screen.orientation.lock 'landscape'
    else if cordova?.plugins?.screenorientation?.setOrientation?
      console.log "locking screen using set orientation"
      cordova.plugins.screenorientation.setOrientation 'landscape-primary'

  # Undo only what lockLandscapeOrientation can have done, and never throw.
  # Card 6ab2f53f0d433c0db46543a7 (CrashLog c2415bb): the lock is gated on
  # @isApp() but this unlock called screen.orientation.unlock() in every
  # browser. Firefox throws "SecurityError: The operation is insecure." from
  # unlock() when nothing is locked, and this runs in game_layout's
  # componentWillUnmount — so a Firefox parent leaving a game got the error
  # screen on the dashboard they were going to.
  unlockLandscapeOrientation: ->
    if @bridge?
      @bridge.callHandler 'unlockLandscape', {retVal: false}, (responseData) ->
        console.log("JS received response:", responseData)
    else if @isApp() && 'screen' of window && 'orientation' of window.screen
      console.log "UnLocking using SCREEN!"
      try
        window.screen.orientation.unlock?()
      catch err
        console.warn "[orientation] unlock refused by this browser: #{err?.name}: #{err?.message}"

  # Returns a Promise resolving to fraction words for the given locale.
  # Caches by locale so the server is only hit once per locale per session.
  # Deduplicates in-flight requests so rapid calls share the same promise.
  getFractionWords: (locale) ->
    @_fractionWordsCache ||= {}
    @_fractionWordsPending ||= {}
    if @_fractionWordsCache[locale]?
      return Promise.resolve(@_fractionWordsCache[locale])
    if @_fractionWordsPending[locale]?
      return @_fractionWordsPending[locale]
    if typeof @loopbackAPI.TranslatablePattern?.getFractionWords != 'function'
      console.warn "getFractionWords: remoteMethod not available (server restart needed?)"
      return Promise.resolve(null)
    p = @loopbackAPI.TranslatablePattern.getFractionWords({locale: locale}).then (response) =>
      @_fractionWordsCache[locale] = response.data.fractionWords
      delete @_fractionWordsPending[locale]
      return @_fractionWordsCache[locale]
    .catch (err) =>
      console.warn "getFractionWords failed for #{locale}:", err
      delete @_fractionWordsPending[locale]
      return null
    @_fractionWordsPending[locale] = p
    return p

  # Synchronous version: returns cached fraction words immediately, or null on a cache miss.
  # On a miss it kicks off a background fetch so the next call will be a hit.
  getFractionWordsSync: (locale) ->
    @_fractionWordsCache ||= {}
    if @_fractionWordsCache[locale]?
      return @_fractionWordsCache[locale]
    @getFractionWords(locale)  # fire-and-forget, populates cache for next call
    return null

  iosManageSubscription: ->
    if @bridge?
      console.log "Calling Launch Manage Screen"
      @bridge.callHandler 'launchManageScreen', {group: "21437103"}, (responseData) ->
        console.log "We back!"

  # A link out to Safari, behind the iOS shell's parental gate (its
  # openInBrowser handler). Answers false where there is no iOS bridge, so the
  # caller can navigate in place instead (card 6abdc5fa7009a562af26012d).
  openInBrowser: (url) ->
    return false unless @bridge?
    @bridge.callHandler 'openInBrowser', {url: url}, (responseData) ->
      console.log "openInBrowser answered"
    true

  iosSubscribe: (email) ->
    if @bridge?
      @bridge.callHandler 'launchSubscribeScreen', {group: "21437103", email: email}, (responseData) ->
        console.log "We back!"

  # The two shells want DIFFERENT strings for the same destination, and on v2
  # that difference was invisible because the app was served at the origin
  # root. A v3 instance serves its client at /app, which splits them:
  #
  #   iOS     loads the value AS A PAGE — ViewController.m:146 does
  #           URLWithString + loadRequest, and persists it as SERVER. It needs
  #           the page URL, ".../app".
  #   Android never loads it as a page. Its local shell uses the value as a
  #           PREFIX — elv2android/www/js/index.js:27 builds
  #           `basePath = server + "api"` and :37 loads `server + "android"`.
  #           It needs the bare origin, or it asks for ".../appapi".
  #
  # `assets` is Android-only by design, and the bridge signature reflects that:
  # iOS renders a remote page that already carries its own asset host, while
  # Android injects a remote script into a LOCAL page and must be told where
  # the bundle lives.
  switchServer: (server, assets, page) ->
    page ?= server
    if @bridge?
      @bridge.callHandler 'switchServer', page, (responseData) ->
        console.log("changed Server received: ", responseData)
    else if bowserRes.os.name == 'Android'
      window.switchServer?(server, assets)

  initialize: (login_tree) ->
    console.log "Initialize called with:"
    console.dir login_tree
    @setup(login_tree)
    @loadDate = moment()
    if !@activeStudentIndex? || !@activeStudentId?
      @activeStudentIndex = 0
      @setActiveStudentIndex(@activeStudentIndex)

  setup: (login_tree) ->
    #console.dir login_tree
    @account = login_tree.account
    @login = login_tree
    # THIS BROWSER REMEMBERS WHO SIGNED IN — card 6aada89a1f4a894e18d2ce0c.
    # Written here rather than at the login call because this is the one place
    # every route to a session passes through: password, Clever, a server-minted
    # deep link, a masquerade, a reload on a cached token. Ids and the account
    # email only. It is what lets a crash on the LOGIN page — where all three of
    # today's pre-login fingerprints live — still name the family whose device
    # it is, flagged as inferred.
    try
      rememberIdentity getIdentity()
    catch err
      console.warn "could not record the last-known identity: #{err?.message or err}"
    unless @loopbackAPI.isStudentSession?()
      window.app.trackUser(@login)

    # BACKFILL :: when a user has an ipstack, but not a user_agent, we should fill it in
    #          :: don't use the app, though, since that's probably wrong. we wait
    #          :: since it may take some time for the isApp() init to finish
    setTimeout () ->
      login = window.app.login
      if login?.ipstack? && !login.ipstack.user_agent? && !window.app.isApp() && !window.app.isStudentLock()
        login.ipstack.user_agent = window.navigator.userAgent
        window.app.loopbackAPI.Login.patchOne({id: login.id}, {data: ipstack: login.ipstack}).catch (err) =>
          console.error "Failed to backfill user agent:"
          console.dir err
    , 2000

    # disable student sharing on non-teacher accounts
    delete @login.sharedStudents unless @account.type == 'teacher'

    # split out students into normal, shared, and invited
    pendingStudents = @students
    pendingDeltas = @deltas
    @students = []
    @deltas = []
    @parentInvitations = []
    #console.log "Running Setup: Here is all the students"
    #console.dir @account.students
    for student in @account.students
      if student.invitation
        @parentInvitations.push student
      else
        @students.push student
        @deltas.push {}
    @restorePendingStudentEdits pendingStudents, pendingDeltas
    @sharedStudents = (@login.sharedStudents || [])

  # UNSAVED STUDENT EDITS SURVIVE A MID-EDIT RELOAD.
  # Card 6aa4bc0cf57a028d25a93d5d.
  #
  # setup() above rebuilds @students and @deltas out of the account the server
  # just sent, and Manage Account > Students reads both: the form's fields come
  # from @students, and Save patches only the fields @deltas names. Typing in
  # that form sets window.app.dirty (Forms/student.coffee), so the NEXT route
  # resolve to ask needsRefresh() gets `true` and refresh() lands a fresh
  # account WHILE THE PARENT IS STILL TYPING. Everything typed so far went back
  # to the stored value, and Save then carried only what had been typed after
  # the reload — the name gone, the birth date rebuilt from the ORIGINAL month
  # and day with just the new year, and no error anywhere. It is a race with
  # the network, so it bites whoever types fastest.
  #
  # Carry the unsaved fields across: the ones the delta names, and only those.
  # Every field nobody has touched still takes the server's value, which is what
  # the refresh was for. Matched by student id, so a student who has gone away
  # while the form was open does not come back.
  restorePendingStudentEdits: (pendingStudents, pendingDeltas) ->
    return unless pendingStudents?.length and pendingDeltas?.length
    for pending, index in pendingStudents
      delta = pendingDeltas[index]
      continue unless pending?.id? and delta?
      edited = (field for field, changed of delta when changed)
      continue unless edited.length
      current = null
      currentIndex = -1
      for student, i in @students when "#{student.id}" == "#{pending.id}"
        current = student
        currentIndex = i
        break
      continue unless current?
      console.log "Keeping unsaved edits for student #{pending.id}: #{edited.join(', ')}"
      for field in edited
        current[field] = pending[field]
        @deltas[currentIndex][field] = true
    return

  needsRefresh: ->
    now = moment()
    if @dirty? && @dirty
      @dirty = false
      return true
    else if @loadDate?
      return now.diff(@loadDate, 'm') > 30
    # NEVER LOADED IS THE STRONGEST REASON TO LOAD — card
    # 6aade038bf4219e77902d92f. No @loadDate means no account has ever been
    # fetched into this Application, and this used to answer `false`: every
    # route resolve says `if needsRefresh() then refresh() else null`, so a
    # screen entered without going through the boot initialize() rendered
    # against an Application that had never been told anything. Every state
    # that asks this is behind requireLogin, so there is a session to load
    # with.
    return true unless @loadDate?
    return false

  isStudentLock: ->
    return (@loopbackAPI.currentStudentId? && @loopbackAPI.currentStudentId!="") || @loopbackAPI.isStudentSession?()

  studentUrl: (token, student)=>
    # Student-scoped tokens: uid is the student ID, no studentId param needed
    isStudentToken = token?.startsWith?('StudentAuth_')
    uid = if isStudentToken then student.id else @loopbackAPI.currentUserId
    params = "access_token=#{token}&uid=#{uid}&new_user=true"
    params += "&studentId=#{student.id}" unless isStudentToken
    # /app, not the site root: the root is the marketing site, and only /app
    # reads access_token (app-route.coffee), so a root link opened from a text,
    # an email or a phone camera never signs the student in (card
    # 6aa4b6c8f57a028d25a93d39).
    if @isApp() && @isAndroid()
      url = "#{window.config.server}/app?#{params}"
    else if window.SERVER?
      # Assigned nowhere today, but a shim that defines it must not bring the
      # root-URL link back (card 6aa645f113abca47a42a3a75).
      url = "#{window.SERVER.replace(/\/+$/, '')}/app?#{params}"
    else
      url = "#{window.location.protocol}//#{window.location.host}/app?#{params}"
    console.debug "Student url is: #{url}"
    return url

  refresh: ->
    fetch =
      id: @loopbackAPI.currentUserId
    obj = {}
    obj.studentId = @loopbackAPI.currentStudentId if @loopbackAPI.currentStudentId? && @loopbackAPI.currentStudentId!=""
    return @loopbackAPI.Account.getAccount(fetch, obj).then (response) =>
      student = response.data.login.account.students[0] || response.data.login.sharedStudents[0]
      if obj.studentId && student?.id != obj.studentId
        console.error "Invalid student id: logging out"

        # match the behavior of loopback api on authorization failure
        @loopbackAPI.clearUser()
        window.location.hash = ''
        if window.location.search
          window.location.search = ''
        else
          window.location.reload()

        # since the page should reload, there is no need to throw an error, as
        # that just causes the error screen to appear needlessly
        return new Promise (resolve, reject) => return null
      else
        # THE DASHBOARD IS WHERE A STALE TAB CATCHES UP — card
        # 6aad9d36bb8767fbeba89f28. Owner, 2026-09-18: "When someone hits the
        # dashboard and does getAccount, if there is a new version we should
        # reload."
        #
        # This is the one call every returning session makes before it does
        # anything else, and nothing is in progress at this moment — no question
        # on screen, no answer waiting to be recorded. That is what makes it the
        # safe place, and why the reload goes BEFORE initialize() rather than
        # after: initialize is what starts drawing, and there is no point
        # rendering a dashboard from a bundle we are about to throw away.
        #
        # Every guard lives in client_version: no header means no reload, a
        # dev build means no reload, and the sessionStorage guard is written
        # before location.reload() so a mis-stamped server cannot loop the tab.
        # The native shell loads the same bundle through the same code, so it
        # gets this for free.
        #
        # INITIALIZE FIRST, THEN SCHEDULE THE RELOAD — card
        # 6aae2221ed08d5788a4e1e14. This line used to read
        #
        #     return response if reloadIfUpdateAvailable('dashboard getAccount')
        #
        # which skipped @initialize, and @initialize is what assigns
        # @account. `location.reload()` does not stop anything — it schedules
        # a navigation and returns — so boot carried straight on to
        # app-route's `account_type = window.app.account.type` and threw. The
        # boundary rendered the Application Error screen.
        #
        # MEASURED IN PRODUCTION, 2026-09-18 11:45 PM MT (CrashLog fingerprint
        # 2f630b9d): a parent on iPhone Safari, still on the 3.20 bundle,
        # opened /app and got the crash screen instead of a silent refresh.
        # Every client still on the old bundle would have hit it exactly once
        # on its next dashboard load — the first impression of the roll.
        # It is not the account screen's bug: the throw is in the BOOT path,
        # so every /app route was affected wherever the parent happened to be.
        #
        # The original ordering had a real reason — no point rendering from a
        # bundle we are about to throw away — and it is not worth a crash
        # screen. Owner's call on the card: keep the response, set the
        # account, then schedule the reload, so the render is correct even if
        # the reload is slow, blocked, or never arrives. The cost is one
        # correct stale render; the cost of the other order was measured.
        @initialize response.data.login
        scheduleReloadIfUpdateAvailable 'dashboard getAccount'
        return response

  isUnsubscribedTeacher: () ->
    if @account?.type? && @account.type == 'teacher'
      if @account.status == 'Trial'
        return true
      else if moment(@account.subscription_end).isBefore(moment())
        return true
    
    return false

  isClassroomSubscriber: () ->
    if @account?.type? && @account.type == 'teacher' && @account?.status == 'Subscribed'
      if moment(@account.subscription_end).isAfter(moment())
        return true
    
    return false

  isSharedStudent: (id) ->
    for student in @sharedStudents
      if student.id == id
        return true
    return false

  refreshActiveStudent: (data) ->
    if @activeStudentIndex < @students.length
      @students[@activeStudentIndex] = data
      return true
    else if (@activeStudentIndex - @students.length) < @sharedStudents.length
      @sharedStudents[@activeStudentIndex - @students.length] = data
      return true
    else
      console.error "Refresh Active Student failed!"
      return false

  setActiveStudentIndex: (index) ->
    student = @getStudent(index)
    if student?
      @activeStudentId = student.id
      @activeStudentIndex = index
      return true
    else
      console.error "Invalid student index: #{index}"
      return false

  setActiveStudentId: (id) ->
    for student, index in (@students.concat(@sharedStudents))
      if student.id == id
        @activeStudentId = student.id
        @activeStudentIndex = index
        console.log "Active student index is: #{@activeStudentIndex}"
        return true
    console.error "Invalid student id: #{id}"
    return false

  getActiveStudent: ->
    return @getStudent(@activeStudentIndex)

  getStudent: (index) ->
    # NO INDEX AND NO LIST ARE BOTH "NOBODY", NOT A CRASH — card
    # 6aade038bf4219e77902d92f. Rendered before the first account fetch,
    # `@students[index]` was `undefined[undefined]` and threw
    # "Cannot read properties of undefined (reading 'undefined')" out of a
    # React render, which the root ErrorBoundary turns into the ErrorScreen.
    # The constructor now keeps both lists empty, and this stays defensive
    # because a caller may equally hand us an index nobody has set yet: an
    # empty or loading dashboard is a screen, and the error screen is not.
    return undefined unless index?
    students = @students ? []
    shared = @sharedStudents ? []
    # indices go through students first, then through shared students
    return students[index] || shared[index - students.length]

  getStudentById: (id) ->
    for student in @students.concat(@sharedStudents)
      if student.id == id
        return student
    console.error "Could not find student with id #{id}!"
    return null

  digestParams: (props) ->
    if props.params?.studentId?
      @setActiveStudentId props.params.studentId

  # The locale to filter game voices for, and the voice locale it maps to.
  # locale-to-voice-mapping.json collapses regions onto the one that has
  # voices ('en-CA' -> 'en-US'), so the two differ more often than not; both
  # are logged, because the card this comes from was diagnosed off exactly
  # that pair in the console.
  #
  # `studentId` IS THE POINT, not a convenience. The games route resolves run
  # BEFORE digestParams latches the student the URL names, so the active
  # student during a resolve is the one being navigated AWAY from. Reading it
  # there filters the list for the previous child — measured on the seat
  # 2026-09-11: arriving at the en-GB child's games page logged
  # "locale en-US", then "Active student index is: 1". So the routes hand over
  # the student they are navigating TO, and only a caller with no route
  # context (teacher.coffee) falls back to the active one.
  gameVoiceLocaleFor: (studentId) ->
    student = if studentId? then @getStudentById(studentId) else null
    student ?= @getActiveStudent()
    studentLocale = student?.preferred_language || student?.locale || 'en-US'
    return {studentLocale, voiceLocale: (localeToVoiceMapping[studentLocale] || studentLocale)}

  # PiperVoice ids, out of `allVoiceIds`, that actually speak `voiceLocale`.
  # Cached per locale: switching a student back and forth costs no round trip.
  voiceIdsForLocale: (voiceLocale, allVoiceIds) ->
    @_localeVoiceIds ?= {}
    @_localeVoiceIds[voiceLocale] ?= @loopbackAPI.PiperVoice.find({
      where: {id: {inq: allVoiceIds}, locale: voiceLocale}
    }).then((voiceResponse) -> new Set(v.id for v in voiceResponse.data))
    .catch (err) =>
      delete @_localeVoiceIds[voiceLocale]   # don't cache a transient failure
      throw err
    @_localeVoiceIds[voiceLocale]

  # `studentId` is the student the caller is navigating to. Omit it and the
  # currently active student is used.
  loadGames: (studentId) ->
    # The cache is keyed by VOICE LOCALE, and that is the whole point of it
    # being written this way (card 6aa4313530706c48305d2195). This used to
    # cache one `@games` list whose piperVoiceIds had been filtered — in
    # place, destroying the original — to whichever locale the active student
    # happened to have on the first load of the session. Change the student's
    # language, or switch to a student with a different one, and every later
    # route resolve returned that stale list: the game random-picked a voice
    # with no audio for the current locale, getManifest refused it, and every
    # phrase fell through to the browser's speechSynthesis. Only a full page
    # reload cleared it.
    #
    # So: @_gamesRaw holds the rows as fetched, never filtered; @games is a
    # per-locale VIEW built from copies of them. getGame() reads @games, so
    # the view stays the current-locale one, and any route resolve after a
    # language change rebuilds it.
    {studentLocale, voiceLocale} = @gameVoiceLocaleFor(studentId)
    if @games? and @gamesVoiceLocale is voiceLocale
      return Promise.resolve(@games)

    # The PROMISE is cached, not just its result: two route resolves can land
    # in here at once (studentRefresh + games on /play), and caching the
    # result alone would fire two identical Game.find calls.
    unless @_gamesRaw?
      @_gamesRaw = @loopbackAPI.Game.find({order: 'createdAt DESC', include: 'gameTheme'})
        .then (response) =>
          console.log "LOADED GAMES:"
          console.dir response.data
          return response.data
        .catch (err) =>
          delete @_gamesRaw   # don't cache a transient failure
          throw err

    return @_gamesRaw.then (rawGames) =>
      # Collect all unique piperVoiceIds across games
      allVoiceIds = new Set()
      for game in rawGames
        if game.piperVoiceIds?.length > 0
          allVoiceIds.add(id) for id in game.piperVoiceIds

      if allVoiceIds.size == 0
        @gamesVoiceLocale = voiceLocale
        @games = rawGames
        return @games

      # Fetch only voices matching the student's locale
      return @voiceIdsForLocale(voiceLocale, Array.from(allVoiceIds)).then (validIds) =>
        console.log "🎙️ Filtered piperVoiceIds for locale #{studentLocale} (voice: #{voiceLocale}): #{validIds.size} of #{allVoiceIds.size}"
        @games =
          for game in rawGames
            if game.piperVoiceIds?.length > 0
              Object.assign({}, game, piperVoiceIds: game.piperVoiceIds.filter((id) -> validIds.has(id)))
            else
              game
        @gamesVoiceLocale = voiceLocale
        return @games

  # The student locales the games can actually speak.
  #
  # The language picker offers all 377 locales in locales.json, but audio only
  # exists for the PiperVoices the Game rows reference. On any other locale the
  # child is read the ENGLISH template text by a browser voice tagged with
  # their language — a broken experience the picker advertised as supported
  # (card 6a81273b157b2ba03490a4db). Resolved from live data through the same
  # locale -> voice mapping loadGames filters on, so the list widens by itself
  # as soon as audio is generated for another voice; nothing here is a
  # hand-maintained list of languages.
  # Candidate AudioLocaleShape ids for (voice, student locale) — card 6a8b9d6e.
  # AudioGeneration rows carry a small localeShapeId instead of the old
  # generatedLocales array; the shape catalog says which shapes contain a given
  # locale. Fetched once per (voice, locale) per session and cached (the
  # catalog is a few hundred tiny rows). Resolves to an array of id strings —
  # possibly empty, which means "this voice has no audio for that locale".
  getAudioShapeIds: (voiceId, locale) ->
    # Sessions minted mid-enrollment may not see this model (same failure mode
    # loadAudioLocales documents) — reject instead of TypeError-ing so the
    # caller's .catch fallback path handles it.
    unless @loopbackAPI.AudioLocaleShape?
      return Promise.reject(new Error('AudioLocaleShape not visible to this session'))
    @_audioShapeIds ?= {}
    key = "#{voiceId}:#{locale}"
    @_audioShapeIds[key] ?= @loopbackAPI.AudioLocaleShape.find({
      where: {voiceId: voiceId, locales: locale}
      fields: {id: true}
    }).then((response) -> (row.id for row in (response?.data || [])))
    .catch (err) =>
      delete @_audioShapeIds[key]   # don't cache a transient failure
      throw err
    @_audioShapeIds[key]

  loadAudioLocales: ->
    return Promise.resolve(@audioLocales) if @audioLocales?

    # NOT EVERY SESSION CAN SEE Game/PiperVoice, and this used to take the
    # whole signup down with it. A Login created mid-enrollment carries
    # Student/Account/Login but NOT Game or PiperVoice, so `@loopbackAPI.Game`
    # is undefined and the old unguarded `.find` threw
    # "Cannot read properties of undefined (reading 'find')" out of
    # student.coffee's componentDidMount. componentDidMount throws are not
    # catchable by the caller's `?.then?`, so it went straight to the error
    # boundary: step 2 of enrollment is the student form, so EVERY new
    # customer hit the error screen and no one could finish signing up.
    #
    # null means "could not find out" and is deliberately NOT [] — [] means
    # "no locale has audio" and would empty the picker. student.coffee gates
    # on `audioLocales?`, so null restores the pre-filter behaviour: every
    # locale offered, and the "only languages the games can speak" hint
    # hidden, because with no data we cannot honestly claim it.
    unless @loopbackAPI?.Game?.find? and @loopbackAPI?.PiperVoice?.find?
      console.warn "🎙️ Game/PiperVoice are not on this session's API surface — offering every locale unfiltered"
      return Promise.resolve(null)

    fallback = (err) =>
      # Same reasoning for a REFUSED read (403/404) as for an absent model:
      # degrade to unfiltered rather than reject, because an unhandled
      # rejection here is a dead enrollment step.
      console.warn "🎙️ Could not resolve audio locales (#{err?.message or err}) — offering every locale unfiltered"
      return null

    return @loopbackAPI.Game.find({}).then((response) =>
      allVoiceIds = new Set()
      for game in response.data
        allVoiceIds.add(id) for id in (game.piperVoiceIds || [])

      if allVoiceIds.size == 0
        @audioLocales = []
        return @audioLocales

      return @loopbackAPI.PiperVoice.find({where: {id: {inq: Array.from(allVoiceIds)}}}).then((voiceResponse) =>
        voiceLocales = new Set(v.locale for v in voiceResponse.data)
        @audioLocales = (code for code of locales when voiceLocales.has(localeToVoiceMapping[code] || code))
        console.log "🎙️ Locales with game audio: #{@audioLocales.length} of #{Object.keys(locales).length}"
        return @audioLocales
      ).catch(fallback)
    ).catch(fallback)

  cache: {}
  play: (soundId) ->
    if soundId of @cache
      @cache[soundId].stop()
      @cache[soundId].play()
    else
      @cache[soundId] = createjs.Sound.play soundId

    if @cache[soundId].playState == 'playFailed'
      badSrc = @cache[soundId].src
      if typeof(badSrc) == 'object'
        badSrc = JSON.stringify(badSrc)
      console.error "Failed to play #{soundId} [#{badSrc}] (playState indicates failure). Removing from cache..."
      delete @cache[soundId]
      return null

    return @cache[soundId]

  flushSounds: (sounds) ->
    for item in sounds when item.id of @cache
      delete @cache[item.id]

  flushSoundCache: ->
    @cache = {}

  getGame: (id) ->
    if @games? && @games.length > 0
      retGame = game for game in @games when game.id is id
      return retGame
    else
      return null

  setupWebViewJavascriptBridge: (callback) ->
    if window.WebViewJavascriptBridge?
      console.log "WebViewJavascriptBridge exists"
      return callback(WebViewJavascriptBridge)
    if window.WVJBCallbacks?
      console.log "WVJBCallbacks exists"
      return window.WVJBCallbacks.push(callback)
    window.WVJBCallbacks = [ callback ]
    WVJBIframe = document.createElement('iframe')
    WVJBIframe.style.display = 'none'
    WVJBIframe.src = 'https://__bridge_loaded__'
    document.documentElement.appendChild WVJBIframe
    setTimeout (->
      document.documentElement.removeChild WVJBIframe
      return
    ), 0
    return

  clearQRFlag: () ->
    sessionStorage?.removeItem("AttemptedQRLogin")

  setQRFlag: () ->
    sessionStorage?.setItem("AttemptedQRLogin", "true")

  getQRFlag: () ->
    sessionStorage?.getItem("AttemptedQRLogin") == 'true'

  # A LINK WHOSE access_token COULD NOT AUTHENTICATE — card 6aae789375583968aa813992.
  #
  # The boot branches install whatever the URL carries and then boot as signed
  # in. A token minted before the v3 cutover (an old QR sheet, an old email
  # link) fails ClientAPI's <Model>Auth_ framing, so setUser clears the session
  # it was asked to install — and the branch carried on to refresh(), which
  # called Account.getAccount on an ANONYMOUS manifest, where that method does
  # not exist. The family got "We have encountered an error" with no way
  # forward (production CrashLog fingerprint 72970e68, iPhone, 2026-09-19).
  #
  # sessionStorage, and the same shape as the QR flag above, for the same
  # reason: the message has to survive start_react() and the history rewrite
  # that strips the dead token out of the URL, and it must not outlive the tab.
  clearStaleLinkFlag: () ->
    sessionStorage?.removeItem("StaleAccessTokenLink")

  setStaleLinkFlag: () ->
    sessionStorage?.setItem("StaleAccessTokenLink", "true")

  getStaleLinkFlag: () ->
    sessionStorage?.getItem("StaleAccessTokenLink") == 'true'

  handleQRCode: (text, onError) ->
    # parse the url data
    parseURL = ( url = location.href ) ->
      params = {}
      ( ( parts = part.split( "=" ) ) && params[ parts[0] ] = parts[1] for part in ( url.split "?" ).pop().split "&" if url.indexOf( "?" ) != -1 ) && params || {}
    params = parseURL text

    # extract data and attempt to log in, or call error handler
    if params.access_token?
      # For StudentAuth_ tokens, uid is the student ID and there's no studentId param
      if params.access_token.startsWith('StudentAuth_')
        @loopbackAPI.setUser(params.access_token, params.uid)
      else
        @loopbackAPI.setUser(params.access_token, params.uid, undefined, params.studentId)
      @loopbackAPI.resetAuthHeader()
      @setQRFlag()

      if window.teacher_mode
        # if we're on the teacher route, redirect back to normal application
        # /app — the site root is the marketing site (card 6aa4b6c8f57a028d25a93d39)
        console.log "Redirecting to the application"
        window.location = '/app'
      else
        window.location.reload(true)
    else
      console.error "Invalid QR Code: #{text}"
      onError?("Invalid QR code. Please try a different code.")

  scanQR: (onError) ->
    if @bridge?
      @bridge.callHandler 'scanQR', {retVal: true}, (responseData) =>
        if responseData.retVal == true
          console.warn "iOS QR Handler :: Detected old version of app. Ignoring response..."
        else if responseData
          @handleQRCode responseData, onError
        else
          console.log "iOS QR Handler :: Received no data."
    else if bowserRes.os.name == 'Android' && QRScanner?
      QRScanner.show (status) ->
        console.log "STatus"
        console.dir status

      handleError = (err) ->
        console.error "Android QR Scanner Error: #{err.name}"

        if err.name == 'BACK_CAMERA_UNAVAILABLE'
          msg = "Cannot access the camera on this device."
        else if err.name == 'CAMERA_ACCESS_DENIED'
          msg = "Please enable camera permissions to login via QR codes."
        else
          msg = "An error occurred in the QR code reader. Please try again."
        onError?(msg)

      QRScanner.prepare (err, status) =>
        return handleError(err) if err?

        QRScanner.scan (err, text) =>
          QRScanner.hide =>
            QRScanner.destroy =>
              return handleError(err) if err?
              @handleQRCode text, onError
    else
      console.error "No QR reader available!"

  isFacebookApp: ->
    ua = navigator.userAgent || navigator.vendor || window.opera
    return /(FBAN|FBAV)/.test(ua)

  isApp: ->
    return @bridge? || (window.config.isAndroid? && window.config.isAndroid)

  supportsWebGL: ->
    return false if bowserRes.os.name == 'iOS' && bowserRes.os.version[0] is '9'
    return true

  supportsToLocaleString: ->
    if @isIOS()
      vers = bowserRes.os.version || ''
      primary_regex = /^([0-9]+)/
      if m = vers.match(primary_regex)
        primary_version = parseInt(m[1])
        return (primary_version >= 10)

    return true

  # checks screen size requirements to see if the user is on a device that may
  #   be too small to render the curriculum legibly
  supportsAlgebra: () =>
    # get the current window size, and use a blunt size check here
    width = window.innerWidth
    height = window.innerHeight
    smallest = Math.min(width, height)
    if smallest <= 440
      return false

    return true

  # older versions of iOS have problems with iframes (they don't respect CSS height)
  # so they need an additional wrapper div to fake it
  needsIFrameWrapper: ->
    if @isIOS()
      vers = bowserRes.os.version || ''
      primary_regex = /^([0-9]+)/
      if m = vers.match(primary_regex)
        primary_version = parseInt(m[1])
        return (primary_version <= 12)

    return false

  isTouchDevice: ->
    return bowserRes.platform.type == 'mobile' || bowserRes.platform.type == 'tablet'

  isSafari: ->
    return bowserRes.browser.name == "Safari"

  isChrome: ->
    return bowserRes.browser.name == 'Chrome'

  isOpera: ->
    return bowserRes.browser.name == 'Opera'

  isEdge: ->
    return bowserRes.browser.name == 'Edge'

  isFirefox: ->
    return bowserRes.browser.name == 'Firefox'

  isAndroid: ->
    return bowserRes.os.name == 'Android'

  isIOS: ->
    return bowserRes.os.name == 'iOS'

  # A mouse or trackpad is attached. The Chromebook app runs in Android's
  # WebView with an Android user agent, so it cannot be told from an Android
  # tablet by name; its trackpad is what it has that a phone does not (card
  # 6abb2af786d61b9a8024b5f0).
  hasFinePointer: ->
    return !!window.matchMedia?('(any-pointer: fine)')?.matches

  isChromebook: ->
    # NOTE: chromebooks are only somewhat obnoxious
    #     : - if accessing with Chrome, the OS is set properly
    #     : - if in App, it comes across as 'Android'  / 'Chrome' with a weird version string
    #         see: https://developer.chrome.com/multidevice/user-agent
    CHROME_REGEX = /[^A-Za-z]Version\/[0-9]\.[0.9]/
    userAgent = window.navigator.userAgent || ''
    return (bowserRes.os.name == 'Chrome OS') || (@isApp() && @isChrome() && CHROME_REGEX.test(userAgent))

  isInternetExplorer: ->
    return /Internet Explorer/.test(bowserRes.browser.name)

  supportsDatePicker: ->
    return @isIOS()

  isMobile: ->
    return bowserRes.platform.type == 'mobile'

  isAndroidChrome: ->
    return bowserRes.os.name == 'Android' && bowserRes.browser.name == 'Chrome'

  setPrimaryColor: (hex) ->
    return setThemeColor('primary', hex)

  setSecondaryColor: (hex) ->
    return setThemeColor('secondary', hex)

  # helpers for storing/loading session storage locally, since otherwise the
  # variables may be lost from hard refreshes (see https://trello.com/c/XXxiVnZ4)
  durationKey: (student) ->
    "$el-#{student.id}-duration"

  durationDateKey: (student) ->
    "$el-#{student.id}-duration-date"

  getDuration: (student) ->
    storage = window.localStorage
    date = moment().format('YYYY-MM-DD')
    lastDate = storage?.getItem(@durationDateKey(student))
    if lastDate != date
      console.log "Ignoring old duration for #{lastDate}"
      return 0
    else
      return parseInt(storage.getItem(@durationKey(student)))

  addDuration: (student, seconds) ->
    @setDuration(student, @getDuration(student) + seconds)

  setDuration: (student, seconds) ->
    storage = window.localStorage
    try
      storage.setItem(@durationKey(student), seconds)
      storage.setItem(@durationDateKey(student), moment().format('YYYY-MM-DD'))
      return true
    catch err
      console.error "Failed to store duration variables"
      console.dir err
      return false

  setInitialRouting: (value) ->
    storage = window.localStorage
    try
      storage.setItem("$el-initial-routing", value)
      return true
    catch
      console.warn "Failed to set initial routing"
      return false

  clearInitialRouting: (value) ->
    storage = window.localStorage
    try
      storage.removeItem("$el-initial-routing")
      return true
    catch
      console.warn "Failed to clear initial routing"
      return false

  # SIGNING OUT TAKES THE SUPPORT CHAT WITH IT — card 6aa95b3fbc2031a10de564f3.
  #
  # The framework calls this on every logout (client_api.coffee clearUser), and
  # it is the only moment the widget's own record can be removed: a real Log
  # Out navigates away, so the widget is destroyed before the host ever gets to
  # tell it the session ended. Left behind, the signed-out parent's conversation
  # uuid was still in localStorage when the guest widget mounted on the
  # marketing homepage, and that widget asked the server for their transcript.
  # An EXPLICIT Log Out — the framework calls this from client_api's logout(),
  # not from the clearUser() that an expired token or an authorization failure
  # takes. Card 6aada89a1f4a894e18d2ce0c: the crash reporter's last-known
  # identity is forgotten when the person says they are leaving, and kept when
  # the session merely lapsed, because a lapsed session is still that family's
  # device and a login-page crash there is exactly what we want to attribute.
  onExplicitLogout: ->
    forgetIdentity()

  onSignOut: ->
    clearAgentWidgetSession()
    # The warm-up cache holds one child's curriculum — which nodes are active
    # for them and what their game is about to say. It is not a credential,
    # but it is that child's, and the next person to sign in on this browser
    # has no business with it (card 6aaa14f67fc38cab6b35ae09). It is also
    # keyed per student, so this is belt and braces rather than the only
    # thing standing between two children.
    clearWarmedManifests()
    # AND THE HOST STOPS SAYING WHO IT WAS — card 6aa998ff1ff4eb57d5032a13.
    #
    # Clearing the widget's record was not enough on its own for any logout
    # that does NOT navigate (/app#/logout, the in-app Log Out button,
    # clearUser on an authorization failure). @login survived sign-out —
    # nothing in this file ever cleared it — so the widget loader's context
    # watcher kept reporting the old accountId a second later, with the token
    # already gone. The widget reads "an account, so not a logout", takes the
    # context, and its trailing saveSession writes the previous person's uuid
    # and accountId straight back into the storage this method had just
    # emptied. Measured on elfeet QA: the record was back ~0.7s after
    # clearSession, and the homepage guest widget then asked for that thread.
    #
    # The title-bar Log Out only escaped it by navigating away before the next
    # watcher tick — a race it happened to win.
    #
    # An identity is not just a token: whoever is reading this object after a
    # sign-out is entitled to be told nobody is signed in.
    @login = null
    @account = null
    @activeStudentId = null

  getPlan: (plans, teacher_plans, currency) ->
    console.debug "Determining user plan"
    # if the user currently has a plan, then default to that one
    if @account.customer?.subscriptions?.data?.length
      console.debug "Using existing customer plan"
      return @account.customer.subscriptions.data[0].plan

    if @account.plan?
      console.debug "Using former subscriber plan..."
      return @account.plan
    
    studentCount = @account.students.length
    rejiggled = {}
    for plan in plans
      limit = plan.product.metadata.studentLimit
      if limit of rejiggled
        rejiggled[limit].push plan
      else
        rejiggled[limit] = [plan]
    console.dir rejiggled
    keys = Object.keys(rejiggled)
    myKey = null
    for key in keys when studentCount <= parseInt(key)
      myKey = key
      break
    myKey = key if !myKey?
    
    # (2) search for plans matching the supplied currency, stripe currency, or ipstack currency
    plans = rejiggled[myKey]
    currency = currency || @account.customer?.currency || @login.ipstack?.currency?.code || 'usd'
    currency = currency.toLowerCase()
    console.debug "Searching for plan with currency #{currency}..."
    plan = undefined
    for p in plans
      if p.currency.toLowerCase() == currency
        plan = p
        break

    # (3) default to searching for USD if primary plan not found (ex. unsupported ipstack currency)
    if !plan?
      console.debug "No plan found for #{currency}, falling back to usd..."
      for p in plans
        if p.currency.toLowerCase() == 'usd'
          plan = p
          break

    # (4) log the plan and return it
    if plan?
      console.log "Selected user plan:"
      console.dir plan
    else
      console.error "No stripe plan found!"
    return plan

  setDelta: (index, obj) ->
    delta = @deltas[index]
    if !delta?
      console.error "No delta for index #{index}!"
      return false

    for k, v of obj
      delta[k] = true

    return true

  getDelta: (index) ->
    # returns 'null' for no changes, which is more convenient than '{}' usually
    student = @students[index]
    delta = @deltas[index] || {}

    if !student?
      console.error "Invalid student index: #{index}"
      return null

    ret = {}
    for k, v of delta
      if v
        ret[k] = student[k]
    return if Object.keys(ret).length > 0 then ret else null

# COPPA gate (card 6a812738157b2ba03490a4af).
#
# This module used to call init_third_party() unconditionally: the
# `donotinitthirdparty` config flag was the only guard, and NOTHING in either
# repo set it at the time, so it was dead code. (It is live now — every shell
# emits it from the instance's DISABLE_THIRD_PARTY_TRACKING env, card
# 6a83adf90069d8263056cafe, common/thirdPartyTracking.coffee. That is a
# per-INSTANCE switch and is independent of this per-SESSION gate.)
# Meanwhile this bundle serves StudentApplication, so a child's session
# initialised Mixpanel, GTM and (in prod) Pinterest and started collecting
# IP/device/behavioural data from a minor. trackUser was already gated on
# isStudentSession — the pixels themselves were not gated at all.
#
# views/index.ejs computes window.__elStudentSession inline in <head>, before
# any tag loads, and that is the authority. Fall back to the same computation
# for the shells that do not set it (teacher.ejs, org.ejs, new_form.ejs), so
# this gate holds whichever page loaded the bundle.
isStudentBrowserSession = ->
  return window.__elStudentSession if typeof window.__elStudentSession == 'boolean'
  try
    return true if (window.location?.search or '').indexOf('access_token=StudentAuth_') != -1
    token = window.localStorage?.getItem('$LoopBack$accessTokenId')
    return true if token? and token.indexOf('StudentAuth_') == 0
    sid = window.localStorage?.getItem('$LoopBack$currentStudentId')
    return true if sid? and sid != '' and sid != 'null'
    false
  catch err
    # Fail CLOSED — see the note in views/index.ejs.
    console.warn "[third-party] cannot determine session type; not initialising trackers"
    true

if window.config?.donotinitthirdparty
  console.log "[third-party] suppressed on this instance (config.donotinitthirdparty)"
else if isStudentBrowserSession()
  console.log "[third-party] student session — third-party trackers not initialised (COPPA)"
else
  init_third_party()

# THE SUPPORT CHAT IS NOT A TRACKER (card 6aa8b5f050645cd1c3e765bc).
#
# It used to be mounted from inside init_third_party, beside Mixpanel and GTM,
# so it was switched off by BOTH gates above. The instance switch is the one
# that hurt: DISABLE_THIRD_PARTY_TRACKING is about what an instance sends to
# other companies, and turning it on silently took away the only way a signed-in
# parent reaches support. On QA that is exactly what happened — no widget in
# /app at all, so it could not even be tested there.
#
# The COPPA gate DOES still apply. A child's session gets no widget: the
# decision the owner settled is that the signed-in PARENT path must have it
# regardless of the tracking switch, not that children start chatting with
# support. isStudentBrowserSession fails CLOSED, so an undeterminable session
# gets no widget either — the safe direction for a minor.
if isStudentBrowserSession()
  console.log "[support-chat] student session — support chat not mounted (COPPA)"
else
  initAgentView(AGENT_WIDGET_SERVER)

